module.exports = __webpack_public_path__ + "img/small.ffa2d42c.jpg";